declare var CONFIG: {
  API: string;
  ENVIRONMENT: string;
  RELEASE: string;
  SENTRY_DSN?: string;
};

export const { API, ENVIRONMENT, SENTRY_DSN, RELEASE } = CONFIG;
